























































import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';

@Component
export default class Language extends Vue {
  @Prop({ required: true })
  locale!: string;
  @Prop({ required: true})
  localeName!: string;
  @Prop({ required: true })
  flagComponentName!: string;

  public get selected() {
    return this.$i18n.locale === this.locale;
  }
}
